import * as constants from '../constants/actions';


/******************************
*******  Synchronous  *********
******************************/

export function commonAlert(text) {
  return {
    type: constants.COMMON_ALERT,
    text,
  };
}

export function commonCloseAlert() {
	return {
    type: constants.COMMON_CLOSE_ALERT,
  };
}

export function commonModalResize() {
	return {
    type: constants.COMMON_MODAL_RESIZE,
  };
}



/******************************
*******  Asynchronous  ********
******************************/





// WEBPACK FOOTER //
// ./src/actions/common.jsx